import { render } from "./HandymanOrder.vue?vue&type=template&id=e3b0dde4"
import script from "./HandymanOrder.vue?vue&type=script&lang=js"
export * from "./HandymanOrder.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__